import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-page animate-fade-in-up">
      <div className="privacy-card">
        <div className="privacy-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        </div>
        <h1>Dasar Privasi & Perlindungan Data</h1>
        <p className="privacy-intro">
          Kami komited untuk melindungi data peribadi anda selaras dengan
          Akta Perlindungan Data Peribadi 2010 (PDPA) Malaysia.
        </p>

        <div className="privacy-section">
          <h2>1. Pengumpulan Data Peribadi</h2>
          <p>
            Kami mengumpul maklumat berikut semasa pendaftaran kempen:
          </p>
          <ul>
            <li>Nama penuh</li>
            <li>Nombor telefon</li>
            <li>Alamat emel (jika diberikan)</li>
            <li>Nombor kad pengenalan (jika diberikan)</li>
            <li>Alamat (jika diberikan)</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>2. Tujuan Pengumpulan</h2>
          <p>Data peribadi anda dikumpul untuk tujuan berikut:</p>
          <ul>
            <li>Pendaftaran dan pengurusan kempen promosi</li>
            <li>Penjanaan dan pengesahan voucher</li>
            <li>Komunikasi berkaitan kempen dan tawaran</li>
            <li>Penambahbaikan perkhidmatan kami</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>3. Perlindungan Data</h2>
          <p>
            Maklumat peribadi anda disimpan dengan selamat dan dilindungi daripada
            akses tanpa kebenaran, pendedahan, pengubahan, atau pemusnahan.
            Kami menggunakan langkah-langkah keselamatan teknikal dan organisasi
            yang bersesuaian untuk memastikan keselamatan data anda.
          </p>
        </div>

        <div className="privacy-section">
          <h2>4. Perkongsian Data</h2>
          <p>
            Kami <strong>tidak akan</strong> berkongsi, menjual, atau memindahkan data peribadi
            anda kepada pihak ketiga tanpa kebenaran anda, kecuali jika dikehendaki
            oleh undang-undang.
          </p>
        </div>

        <div className="privacy-section">
          <h2>5. Penyimpanan Data</h2>
          <p>
            Data peribadi anda akan disimpan selagi ia diperlukan untuk tujuan
            yang dinyatakan di atas, atau seperti yang dikehendaki oleh undang-undang.
            Data yang disimpan dalam peranti anda (localStorage) boleh dipadam
            pada bila-bila masa melalui tetapan pelayar web anda.
          </p>
        </div>

        <div className="privacy-section">
          <h2>6. Hak Anda</h2>
          <p>Anda berhak untuk:</p>
          <ul>
            <li>Mengakses data peribadi anda yang kami simpan</li>
            <li>Membetulkan sebarang maklumat yang tidak tepat</li>
            <li>Menarik balik kebenaran untuk pemprosesan data</li>
            <li>Meminta pemadaman data peribadi anda</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>7. Hubungi Kami</h2>
          <p>
            Jika anda mempunyai sebarang pertanyaan mengenai dasar privasi ini
            atau ingin menggunakan hak anda, sila hubungi kami melalui
            maklumat yang tertera di laman web rasmi kami.
          </p>
        </div>

        <div className="privacy-footer">
          <p>Dasar ini berkuat kuasa mulai Januari 2025 dan mungkin dikemaskini dari semasa ke semasa.</p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
